import { AcademyListing } from "../../../data/academyListings";
import { AcademyIcon } from "./AcademySettingsControls";

const card = {
  background: "#fff",
  border: "1px solid rgba(138,160,174,.18)",
  borderRadius: 16,
  padding: "22px 22px 20px",
  display: "flex",
  flexDirection: "column",
  gap: 16,
  fontFamily: "Lato,system-ui,sans-serif",
  boxShadow: "0 3px 8px rgba(21,65,94,.06)",
};

const coverBase = {
  height: 132,
  borderRadius: 12,
  position: "relative",
  display: "grid",
  placeItems: "center",
  overflow: "hidden",
  backgroundColor: "rgba(200,227,251,.34)",
  backgroundImage:
    "repeating-linear-gradient(135deg,rgba(154,186,227,.34) 0 6px,transparent 6px 14px)",
  border: "1px solid rgba(154,186,227,.5)",
};

function SeekerListingPreview({ rec }: { rec: AcademyListing }) {
  return (
    <div style={card as any}>
      <div
        style={
          (rec.cover
            ? {
                ...coverBase,
                background: `center/cover no-repeat url(${rec.cover})`,
                border: "1px solid rgba(154,186,227,.5)",
              }
            : coverBase) as any
        }
      >
        {!rec.cover && (
          <span
            style={{
              font: "500 11px/1.3 ui-monospace,Menlo,monospace",
              letterSpacing: ".04em",
              color: "#3f7f96",
              background: "rgba(255,255,255,.86)",
              padding: "5px 10px",
              borderRadius: 6,
            }}
          >
            program cover image
          </span>
        )}
        <span
          style={{
            position: "absolute",
            top: 10,
            right: 10,
            width: 28,
            height: 28,
            borderRadius: 999,
            background: "rgba(255,255,255,.94)",
            display: "grid",
            placeItems: "center",
            boxShadow: "0 1px 3px rgba(21,65,94,.18)",
          }}
        >
          <AcademyIcon name="external-link" size={15} color="#15415e" />
        </span>
      </div>
      <div>
        <div
          style={{
            font: "600 0.7rem/1 Lato,sans-serif",
            color: "#3f7f96",
            letterSpacing: ".08em",
            textTransform: "uppercase",
            marginBottom: 8,
          }}
        >
          {rec.kicker || "Kicker"}
        </div>
        <h4
          style={{
            margin: 0,
            font: "700 1rem/1.25 Lato,sans-serif",
            color: "#15415e",
          }}
        >
          {rec.name || "Program name"}
        </h4>
      </div>
      <p
        style={{
          margin: 0,
          font: "500 0.8rem/1.5 Lato,sans-serif",
          color: "#4a6376",
          flex: 1,
        }}
      >
        {rec.desc ||
          "Program description — what it covers, who it is for, and how long it runs."}
      </p>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 12,
          paddingTop: 14,
          borderTop: "1px solid rgba(217,217,217,.7)",
        }}
      >
        <span style={{ font: "500 0.75rem/1.3 Lato,sans-serif", color: "#4a6376" }}>
          {rec.meta || "Source line"}
        </span>
        <span
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 6,
            font: "600 0.8rem/1 Lato,sans-serif",
            color: "#15415e",
          }}
        >
          Open
          <AcademyIcon name="external-link" size={14} color="#15415e" />
        </span>
      </div>
    </div>
  );
}

export default SeekerListingPreview;
